import React, { useEffect } from 'react';

import { BrandkitFailedV1, PdpPageEvents } from '@vp/pdp-events';
import { useLocalizations } from '@vp/ubik-localizations-provider';

import { ToastProvider } from '../components/StickyToast';

export const useBrandkitFailed: ToastProvider = (setToast) => {
  const { t } = useLocalizations();
  useEffect(() => {
    const handleBrandkitFailed = (event: BrandkitFailedV1) => {
      if (event.reason === 'FailedToLoadPreview') {
        setToast({
          skin: 'warning',
          body: <>{t('brandkit-failed-to-load')}</>,
        });
      }
    };

    return PdpPageEvents.listenToBrandkitFailedEventV1(handleBrandkitFailed);
  }, []);
};
